export default __webpack_public_path__ + "static/media/Cheng-Ho Battle Sword.cac21649.jpg";